import React, {Component} from 'react'
import { connect } from 'react-redux'

// import styles
import './stoplockorder.scss'

// Actions
import { StopLockOrder, getOrder } from '../../../actions/orders'
import { createNote, getStandardNotes, createOrDeleteStandardNote } from '../../../actions/notes'
// import components
import Modal from '../../components/Modal'
import UserInfo from '../../components/UserInfo'
// import RadioList from './InputComponents/RadioList/RadioList'

// Elements
import Textarea from '../../elements/textarea'
import Check from '../../elements/check'
import Radio from '../../elements/radio'
import Text from '../../elements/text'
import LabelWrapper from '../../elements/labelWrapper'
import Inline from '../../elements/inline'
import Label from '../../elements/label'
import AddButton from '../../elements/addButton'
import RemoveButton from '../../elements/removeButton'

import { ModalIcons } from '../../elements/icons'

// Utils
import { makeOrderTitle } from '../../../utils/order'
import { translation } from '../../../utils/helpers'
import { hasAccess } from '../../../utils/auth'

class StopLockOrderModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      itemIsStopped: props.item.IsStopped,
      standardNotes: [],
      show: false,
      message: '',
      selectedRadioButtonValue: '-1',
      isRadioSelected: false,
      newDelivery: this.props.newDelivery,
      ApplyToInvoice: false,
      ShowCustomer: false,
      ShowPaintShop: false
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.stopLockOrder = this.stopLockOrder.bind(this)
    this.radioChange = this.onRadioChange.bind(this)
    this.addStandardNote = this.addStandardNote.bind(this)
    this.deleteNoteText = this.deleteNoteText.bind(this)
    this.addNoteText = this.addNoteText.bind(this)
    this.translate = this.translate.bind(this)
  }
  componentDidMount () {
    if (this.props.item.OrderStop) {
      this.setState({
        itemIsStopped: this.props.item.IsStopped,
        message: this.props.item.OrderStop.StoppedMessage,
        selectedRadioButtonValue: this.props.item.OrderStop.TimeAction.toString(),
        ApplyToInvoice: this.props.item.OrderStop.StoppedMessageApplyToInvoice,
        ShowCustomer: this.props.item.OrderStop.StoppedMessageShowCustomer,
        ShowPaintShop: this.props.item.OrderStop.StoppedMessageShowCustomer
      })
    }
    this.props.getStandardNotes().then((res) => {
      this.setState({
        standardNotes: res.data
      })
    })
  }
  addNoteText (text) {
    let noteText = this.state.message
    if (noteText === '') {
      noteText = text
    } else {
      noteText += '\n'
      noteText = noteText.concat(text)
    }
    this.setState({
      message: noteText
    })
  }

  addStandardNote (e) {
    e.preventDefault()
    let inputText = document.getElementsByName('standardNote')[0]
    let noteText = document.getElementsByName('standardNote')[0].value
    if (noteText !== '') {
      let newStandardNote = {
        Id: 0,
        Note: noteText,
        IsDeleted: false
      }
      this.props.createOrDeleteStandardNote(newStandardNote).then((res) => {
        this.setState({
          standardNotes: res.data
        }, () => {
          inputText.value = ''
        })
      })
    }
  }

  deleteNoteText (note) {
    note.IsDeleted = true
    this.props.createOrDeleteStandardNote(note).then((res) => {
      this.setState({
        standardNotes: res.data
      }, () => {
      })
    })
  }

  stopLockOrder (e) {
    e.preventDefault()
    let data = {
      OrderId: this.props.id,
      Message: this.state.message,
      TimeAction: parseInt(this.state.selectedRadioButtonValue),
      NewDelivery: this.state.newDelivery,
      ShowCustomer: this.state.ShowCustomer,
      ShowPaintShop: this.state.ShowPaintShop,
      ApplyToInvoice: this.state.ApplyToInvoice
    }
    if (this.state.itemIsStopped || this.state.isRadioSelected || parseInt(this.state.selectedRadioButtonValue) > 0) {
      this.props.StopLockOrder(data).then((res) => {
        // window.toastr.success(translation('13403'), translation('13424'))
        this.props.onClose()
      }, (err) => {
        var key = err.response.data.DictionaryKey === undefined ? '13404' : err.response.data.DictionaryKey
        window.toastr.error(translation(key), translation('216'))
      })
    } else {
      window.toastr.error(translation('15265'), translation('216'))
    }
  }

  onInputChange (e) {
    if (e.target.type === 'checkbox') {
      this.setState({
        [e.target.name]: (e.target.checked)
      })
    } else {
      let value = e.target.value
      this.setState({[e.target.name]: value})
    }
  }

  onRadioChange (e) {
    let value = e.target.value
    this.setState({
      selectedRadioButtonValue: value,
      isRadioSelected: true // makes sure that when new stop is made any of the radio buttons is clicked
    })
  }
  // kept this in comment in case someone changes their mind.. good UX here
  // checkboxActive () {
  //   if (this.state.message !== '') return false
  //   else return true
  // }
  renderCheckBoxes () {
    return (
      <div>
        <Check id='ApplyToInvoice' name='ApplyToInvoice' value='yes' onChange={this.onInputChange} checked={this.state.ApplyToInvoice} labelText={translation('1785')} />
        <Check id='ShowCustomer' name='ShowCustomer' value='1' onChange={this.onInputChange} checked={this.state.ShowCustomer} labelText={translation('13429')} />
        {(this.props.auth.departmentType === 1 || hasAccess([6], this.props.auth.user.UserType)) && (<Check id='ShowPaintShop' name='ShowPaintShop' value='1' onChange={this.onInputChange} checked={this.state.ShowPaintShop} labelText={translation('17858')} />)}
      </div>
    )
  }

  renderView () {
    const renderStopMessage = () => {
      const renderTitle = () => {
        if (!this.state.itemIsStopped) {
          return (<Label>{translation('149')}:</Label>)
        } else {
          if (this.props.item.OrderStop) {
            let date = this.props.item.OrderStop.StoppedDate.replace('T', ' - ')
            let transformedDate = date.substr(0, (date.length - 3))
            return (
              <Label>
                <UserInfo user={this.props.item.OrderStop.StoppedByUserInfo} />
                {transformedDate}
              </Label>
            )
          }
        }
      }
      const renderStandardNotes = () => {
        if (this.state.standardNotes.length <= 0) return null
        var sNotes = [...this.state.standardNotes]
        var renderedNotes = sNotes.map((note, i) => {
          return (
            <Inline key={i} fillChildNum={[0]} block alignChildren='center'>
              <span>{note.Note}</span>
              {this.state.showEdit === true && (<RemoveButton size='s' onClick={() => this.deleteNoteText(note)} />)}
              <AddButton size='s' onClick={() => this.addNoteText(note.Note)} />
            </Inline>
          )
        })
        return renderedNotes
      }
      const toggleEdit = () => {
        this.setState({
          showEdit: !this.state.showEdit
        })
      }
      const renderOldComment = () => {
        return (
          <div>
            <Textarea name='message' onChange={this.onInputChange} value={this.state.message || ''} />
            <LabelWrapper labelText={<span>{defaultNoteTitle} <img src='/images/icons/edit_16.png' onClick={toggleEdit.bind(this)} /></span>}>
              {renderStandardNotes()}
            </LabelWrapper>
            {this.state.showEdit === true && (
            <LabelWrapper labelText={translation('15201')}>
              <Inline fillChildNum={[0]} block>
                <Text name='standardNote' defaultValue='' />
                <AddButton onClick={this.addStandardNote} />
              </Inline>
            </LabelWrapper>)}
            {this.renderCheckBoxes()}
          </div>)
      }
      const renderNewComment = () => {
        return (
          <div>
            <Textarea name='message' onChange={this.onInputChange} value={this.state.message || ''} />
            <LabelWrapper labelText={<span>{defaultNoteTitle} <img src='/images/icons/edit_16.png' onClick={toggleEdit.bind(this)} /></span>}>
              {renderStandardNotes()}
            </LabelWrapper>
            {this.state.showEdit === true && (
            <LabelWrapper labelText={translation('15201')}>
              <Inline fillChildNum={[0]} block>
                <Text name='standardNote' defaultValue='' />
                <AddButton onClick={this.addStandardNote} />
              </Inline>
            </LabelWrapper>)}
            {this.renderCheckBoxes()}
          </div>
        )
      }
      let defaultNoteTitle = translation('15095')
      if (this.state.standardNotes.length <= 0) {
        defaultNoteTitle = translation('15207')
      }
      return (
        <div>
          {renderTitle()}
          {this.state.itemIsStopped && (renderOldComment())}
          {!this.state.itemIsStopped && (renderNewComment())}
        </div>
      )
    }
    const renderStopTimeAction = () => {
      if (this.state.itemIsStopped && this.state.newDelivery === null) return null
      let department = this.props.item.OrderDepartment
      let time
      if (department === 1) {
        time = this.props.item.BodyShopDeliveryTime
      } else {
        time = this.props.item.Delivery
      }
      const formatDateTimeString = (dateTime) => {
        let dateTimeReplaceT = dateTime.replace('T', '-')
        let dateTimeTimeSplit = dateTimeReplaceT.split('-')
        let transformedDate = ' ' + dateTimeTimeSplit[2] + '.' + dateTimeTimeSplit[1] + '.' + dateTimeTimeSplit[0] + ' ' + translation('15263') + ' ' + dateTimeTimeSplit[3].substr(0, 5)
        return transformedDate
      }
      const renderOldSelection = () => {
        if (this.state.newDelivery !== undefined && this.state.newDelivery !== null) {
          let radioButtons = [
            {Id: 1, Name: translation('15262') + formatDateTimeString(this.state.newDelivery)},
            {Id: 2, Name: translation('15260') + formatDateTimeString(time)}
          ]
          const mapItems = (val, index) => {
            let id = val.Id
            let name = 'selectedRadioButtonValue'
            let idName = name + '_' + id + '_input'
            return (
              <Radio key={index} id={idName} name={idName} value={id} onChange={this.radioChange} checked={this.state.selectedRadioButtonValue === id.toString() ? 'checked' : false} disabled={false} labelText={this.translate(val['Name'])} />
            )
          }
          return (
            // <RadioList title={translation('15264')} subTitle={translation('15259')}
            //   name={'selectedRadioButtonValue'} value={this.state.selectedRadioButtonValue} onChange={this.radioChange}
            //   listItems={radioButtons} checked={false} listItemValName={['Id', 'Name']} translate showTitle showSubTitle />
            <LabelWrapper labelText={translation('15264')}>
              <Label>{translation('15259')}</Label>
              {radioButtons.map(mapItems)}
            </LabelWrapper>
          )
        }
      }
      const renderNewSelection = () => {
        const getValue = () => {
          if (!this.state.isRadioSelected) return '-1'
          else return this.state.selectedRadioButtonValue
        }
        let radioButtons = [
          {Id: 1, Name: translation('47')},
          {Id: 2, Name: translation('15260') + formatDateTimeString(time)},
          {Id: 0, Name: translation('15261')}
        ]

        const mapItems = (val, index) => {
          let id = val.Id
          let name = 'selectedRadioButtonValue'
          let idName = name + '_' + id + '_input'
          return (
            <Radio key={index} id={idName} name={idName} value={id} onChange={this.radioChange} checked={getValue() === id.toString() ? 'checked' : false} disabled={false} labelText={this.translate(val['Name'])} />
          )
        }
        return (
          // <RadioList title={translation('15264')} subTitle={translation('15259')}
          //   name={'selectedRadioButtonValue'} value={getValue()} onChange={this.radioChange}
          //   listItems={radioButtons} checked={false} listItemValName={['Id', 'Name']} translate showTitle showSubTitle />
          <LabelWrapper labelText={translation('15264')}>
            <Label>{translation('15259')}</Label>
            {radioButtons.map(mapItems)}
          </LabelWrapper>
        )
      }
      return (
        <div>
          {this.state.itemIsStopped && (renderOldSelection())}
          {!this.state.itemIsStopped && (renderNewSelection())}
        </div>
      )
    }

    return (
      <div>
        {renderStopMessage()}
        {renderStopTimeAction()}
      </div>
    )
  }

  translate (text) {
    if (isNaN(Number(text))) return text
    return translation(text)
  }

  render () {
    // let icon = 'Stop-White.png'
    let icon = ModalIcons.Stop_Order
    let headerName = makeOrderTitle(this.props.item, null, null, true)
    return (
      <div className='stoplockorder__modal'>
        <Modal {...this.props}
          header={translation('2218') + ' - ' + headerName}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          icon={icon}
          bottomBarProps={{
            actionStyle: 'alert',
            actionLabelText: this.state.itemIsStopped ? translation('2220') : translation('2218'),
            onActionClick: this.stopLockOrder
          }}
        >
          {this.renderView()}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  StopLockOrder,
  getStandardNotes,
  createNote,
  createOrDeleteStandardNote,
  getOrder
})(StopLockOrderModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/StopLockOrderModal/index.js